export default "__VITE_ASSET__Saio_5Rn__"